import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import MainLoader from "../components/sub/MainLoader";

function ProtectedRoute() {
  const authState = useSelector((state) => state.authState.value);
  if (authState === "logout") {
    return <Navigate to={"/login"} replace />;
  } else if (authState === "login") {
    return <Outlet />;
  }
  return <MainLoader />;
}

export default ProtectedRoute;
